// src/api/promptApi.js
import { getApi } from './axiosInstance';

// Fetch all prompts
export const fetchAllPrompts = async () => {
    try {
        const response = await getApi().get('/prompts');
        return response.data;
    } catch (error) {
        console.error('Error fetching prompts:', error);
        throw error;
    }
};

// Fetch specific prompt by ID
export const fetchPromptById = async (id) => {
    try {
        console.log('Fetching prompt with ID:', id);
        const response = await getApi().get(`/prompts/${id}`);
        console.log('Prompt details response:', response.data);
        return response.data;
    } catch (error) {
        console.error(`Error fetching prompt with ID ${id}:`, error);
        if (error.response) {
            console.error('Error response:', {
                status: error.response.status,
                data: error.response.data,
                headers: error.response.headers
            });
        }
        throw error;
    }
};

// Create a new prompt
export const createPrompt = async (promptData) => {
    try {
        const response = await getApi().post('/prompts', promptData);
        return response.data;
    } catch (error) {
        console.error('Error creating prompt:', error);
        throw error;
    }
};

// Delete a prompt by ID
export const deletePrompt = async (id) => {
    try {
        console.log('Attempting to delete prompt with ID:', id);
        const response = await getApi().delete(`/prompts/${id}`);
        console.log('Delete response:', response.data);
        return response.data; // Should return true on success
    } catch (error) {
        console.error(`Error deleting prompt with ID ${id}:`, error);
        if (error.response) {
            console.error('Error response:', {
                status: error.response.status,
                data: error.response.data,
                headers: error.response.headers
            });
        }
        throw error;
    }
};